import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Nabvar } from './nabvar/nabvar';
import { HttpClientModule } from '@angular/common/http';
import { Footer } from './footer/footer';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HttpClientModule, Nabvar, Footer],
  templateUrl: './app.html',
})
export class AppComponent {}
